module.exports = __webpack_public_path__ + "images/file_icons_v2/DMG-3139b094022e97409a00fcd418ab20f6.svg";